export const renderGridLabelColumn = (rowData, col, rowIndex) => {

  const { getLableClass } = col.colSettings

  const columnValue = rowData?.[col.fieldName];
  const displayVal = columnValue.toString().toLowerCase();
  const cssClass = getLableClass(rowData?.[col.fieldName])

  let labelText = "";

  switch (displayVal) {
    case "1":
      labelText = "Ongoing";
      break;
    case "2":
      labelText = "Completed";
      break;
    case "3":
      labelText = "Upcoming";
      break;
    case "yes":
    case "true":
    case "active":
      labelText = "Active";
      break;
    default:
      labelText = "Inactive";
      break;
  }
  return <span className={cssClass}>{labelText}</span>;
};



